import { useMutation } from '@tanstack/react-query';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import {
	BulkAddCounterpartyDto,
	StartBulkAddCounterpartyRes,
} from '@dealstack/shared/lib/generated';

const bulkAddCounterpartyRequest = async ({
	dealId,
	programmeId,
	body,
}: {
	dealId: string;
	programmeId: string;
	body: BulkAddCounterpartyDto;
}) => {
	const endpoint = formatUnicorn(
		API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_BULK_ADD_COUNTERPARTY_POST,
		{ dealId, programmeId }
	);
	const response = await makeRequest<ApiV1.Response<StartBulkAddCounterpartyRes>>({
		endpoint,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(body),
	});
	return response;
};

export const useBulkAddCounterparty = ({
	dealId,
	programmeId,
	onSuccess,
	onSettled,
}: {
	dealId: string;
	programmeId: string;
	onSuccess?: (data: ApiV1.Response<StartBulkAddCounterpartyRes>) => void;
	onSettled?: () => void;
}) => {
	const tMipManage = useTranslationMipManage();

	const handleError = () => {
		showToastV2({
			state: 'error',
			title: tMipManage('documents_page.toast.add_counterparty.error'),
		});
	};

	return useMutation({
		mutationFn: (body: BulkAddCounterpartyDto) =>
			bulkAddCounterpartyRequest({ dealId, programmeId, body }),
		onSuccess,
		onError: handleError,
		onSettled,
	});
};
